//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Service from '@/service/index'
import ExcellentConsultants from '@/components/business/_excellent_consultants'
import HouseCount from '@/components/views/_house_count'
import { TIP_CONTENT } from './const'
import BuildingService from '@/service/building'
import LotteryResults from './_lottery_results'
export default {
    data () {
        return {
            excellent_consultants: [],
            result: {
                ln_number: '',
                ln_result: []
            },
            show_result: {
                show_content: false,
                ln_num_tx: '公证摇号编码',
                show_qa: true,
                coding: '',
                qr_img: 'https://cdn.vip-wifi.com/fangchan/img/qr/chengdu/zxyh.jpeg',
                is_success: false,
                card_names: ''
            },
            house: {
                name: ''
            },
            building: {},
            loading: true,
            building_id: '',
            building_name:'',
            house_id: '',
            show_tip: false,
            tip_content: TIP_CONTENT,
            go_comment_lock: false
        }
    },
    computed: {
        desc () {
            const { ln_result } = this.result
            if (ln_result && ln_result.length) {
                const result = ln_result.filter(({ wish_discard_persons }) => wish_discard_persons != null && wish_discard_persons != undefined)
                console.error('result', result)
                if (this.is_success) {
                    return '恭喜中签，祝您购房顺利哦~~'
                }
                const desc_arr = result.map(({ ln_type, wish_discard_persons }) => {
                    return `${ln_type}${wish_discard_persons}人放弃`
                })
                if (desc_arr && desc_arr.length) {
                    return desc_arr.join('，或') + '可选房哦~'
                }
            }
            return ''
        },
        is_success() {
            const { ln_result } = this.result
            if (ln_result && ln_result.length) {
                return ln_result.some(({ wish_discard_persons }) => wish_discard_persons != null && wish_discard_persons != undefined && Number(wish_discard_persons) <= 0)
            }
            return false
        },
    },
    mounted () {
        const { building_id, house_id } = this.$route.query
        this.building_id = building_id
        this.house_id = house_id
        Service.init().then(this.getData)
    },
    methods: {
        toggleTip () {
            this.show_tip = !this.show_tip
        },
        getData () {
            this.loading = true
            const { regNum, lnNum, house_id: houseId, building_id } = this.$route.query
            this.getBuilding(building_id)
            Service.getLnDetail(houseId, {
                ln_number: lnNum,
                register_number: regNum
            }).then(data => {
                const { ln_result } = data.ln_detail
                this.result = data.ln_detail
                this.house = data.house
                this.loading = false
                this.show_result.show_content = ln_result && ln_result.length
                this.show_result.coding = data.ln_detail.ln_number
                this.show_result.desc = this.desc
                this.show_result.is_success = this.is_success

            })
            this.getExcellentConsultant(building_id)
        },
        async getBuilding (building_id) {
            const data = await BuildingService.getBuilding(building_id)
            this.building_name = data.name
            this.building = data
        },
        getExcellentConsultant (building_id) {
            BuildingService.excellentConsultants(building_id).then((data) => {
                this.excellent_consultants = data.slice(0, 3)
            })
        },
        async goComment(tempFilePath, content) {
            const params = {
                content,
                photos_urls: [tempFilePath]
            }
            try {
                const data = await Service.postBuildingComment(this.building_id, params)
                if (!data) {
                    this.setLock()
                    return
                }
                wx.showToast({
                    title: '发布成功',
                    icon: 'none'
                })
                setTimeout(() => {
                    wx.navigateTo({
                        url: `/pages/building/comments/main?building_id=${this.building_id}`
                    })
                }, 200)
            } catch (error) {
                console.log('upload-img-error', error)
            }
            this.setLock()
        },
        setLock() {
            this.go_comment_lock = !this.go_comment_lock
        },
        joinGroup () {
            wx.navigateTo({
                url: `/pages/building/discuess_group/main?link=${this.building.add_group_url}`
            })
        }
    },
    components: {
        HouseCount,
        LotteryResults,
        ExcellentConsultants
    }
}
